// extracted by mini-css-extract-plugin
module.exports = {"wrap":"MobileBetaNav-module--wrap--1_31N","list":"MobileBetaNav-module--list--3Grma"};